import { render, staticRenderFns } from "./TaxaProgramadoAtendido.vue?vue&type=template&id=9dcb5ae8"
import script from "./TaxaProgramadoAtendido.vue?vue&type=script&lang=js"
export * from "./TaxaProgramadoAtendido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports